import { useState, useEffect } from 'react';
import { Card, CardContent, CardHeader, Button, Alert } from '@mui/material';
import { Link } from 'react-router-dom';

import { useFormik } from 'formik';
import * as Yup from 'yup';

import loadingGif from '../../Assets/loading.gif';
import Api from '../../Services/Api';
import FastTextField from "../FastTextField";
import FastBoolField from "../FastBoolField";
import FormikValidation from "../FormikValidation";
import Decorator from '../Decorator';

function MessageForm(props) {
	const [apiResponse, setApiResponse] = useState(null)
	const [onEdit] = useState(props?.message ? true : false)
	const [loading, setLoading] = useState(false);
	const [displayAlert, setDisplayAlert] = useState(0);

	const formik = useFormik({
		initialValues: {
			title: apiResponse?.title ?? "",
			message: apiResponse?.message ?? "",
			enabled: apiResponse?.enabled ?? "1",
			method: "sms",
			_method: onEdit ? 'put' : 'post',
		},
		validationSchema: Yup.object({
			title:
				Yup.string()
				.min(2, 'Lunghezza minima 2 caratteri')
				.max(50, 'Lunghezza massima 50 caratteri')
				.required('Campo obbligatorio'),
			message:
				Yup.string()
				.min(2, 'Lunghezza minima 2 caratteri')
				.max(1000, 'Lunghezza massima 1000 caratteri')
				.required('Campo obbligatorio'),
			enabled:
				Yup.bool()
				.required('Campo obbligatorio'),
			method:
				Yup.string()
				.oneOf(['sms', 'email'], 'Il valore deve essere uno tra "sms" o "email"')
				.required('Campo obbligatorio'),
		}),
		onSubmit: values => {
			setLoading(true);

			try {
				let currEndpoint = onEdit ? `message/${apiResponse.id}` : 'message';
				Api.post({endpoint: currEndpoint, body: values, contentType : 'application/json'})
					.then(response => {
						setDisplayAlert(1);
					})
					.catch(error => {
						if (error.response?.status === 422) {
							var errors = JSON.parse(error.request.response);
							if (errors.hasOwnProperty('errors')) {
								var alertMessage = "Si sono verificati errori nei dati:";
								for (var errorField in errors.errors) {
									alertMessage += "\n" + errors.errors[errorField].join(',');
								}
								alert(alertMessage);
								setDisplayAlert(0);
								setLoading(false);
							}
							else {
								console.log(error);
							}
							return;
						}
						else {
							console.log(error);
							alert("Errore inatteso!");
						}
						setDisplayAlert(-1);
					});
			} catch (error) {
				console.log(error);
				setDisplayAlert(-1);
			}
		},
		enableReinitialize: true,
	});

	function confirmGoBack(checkChanged) {
		if (checkChanged && Object.keys(formik.touched)?.length > 0) {
			if (!window.confirm("Uscire senza salvare le modifiche?")) {
				return false;
			}
		}
		return true;
	}

	function gotoBack(checkChanged) {
		return (
			<Link to={`/cms/messages`} style={{margin: 'auto'}}
				onClick={e => !confirmGoBack(checkChanged) && e.preventDefault()}
			>
				<Button variant="outlined" sx={{ ml: 3 }}>
					Torna alla lista!
				</Button>
			</Link>
		);
	}

	useEffect(() => {
		try {
			if (onEdit) {
				Api.get({endpoint: `message/show/${props.message}`, contentType : 'application/json'})
					.then(response => {
						setApiResponse(response.data.message);
					})
					.catch(error => {
						console.log(error);
						setApiResponse(null);
						setDisplayAlert(-1);
					});
			}
		} catch (error) {
			console.log(error);
			return (error.response ? error.response?.status : null);
		}
	}, [onEdit]);	// eslint-disable-line react-hooks/exhaustive-deps

	return (
		<form
			autoComplete="off"
			noValidate
			onSubmit={formik.handleSubmit}
		>
			<Card>
				<CardHeader
					title="Modello"
					subheader="Visualizza e modifica i dati del Modello"
				/>
				<CardContent sx={{ pt: 0 }}>
						<div key="name_enabled" className="row styled">
							<div key="title" className="col-md-12">
								<FastTextField loading={loading} required formik={formik} label="Titolo" field="title" />
							</div>
							<div key="message" className="col-md-12">
								<FastTextField loading={loading} required formik={formik} label="Testo del messaggio" field="message"
									multiline
									rows={4}
                                    startdecorator={Decorator}
								/>
							</div>
							<div key="enabled" className="col-md-6">
								<FastBoolField loading={loading} formik={formik} label="Attiva" field="enabled" />
							</div>
						</div>

						<div className="row styled">
							<div className="col">
								{loading && (<>
									{displayAlert === 0 && (
										<img className="pl-3" src={loadingGif} alt="Loading..."/>
									)}
									{displayAlert === -1 && (
										<Alert severity="error">Si è verificato un errore imprevisto. Riprovare più tardi</Alert>
									)}
									{displayAlert === 1 && (
										<Alert severity="success">
											{onEdit ? (
												<>Dati modificati con successo!</>
											) : (
												<>Dati salvati con successo!</>
											)}
											{gotoBack()}
										</Alert>
									)}
								</>)}
								{!loading && (<>
									<Button variant="contained" type="submit">
										{onEdit ? <>Modifica dati</> : <>Invia dati</>}
									</Button>
									{gotoBack(true)}
								</>)}
							</div>
						</div>
						<FormikValidation formikValues={formik.values} formikErrors={formik.errors} formikTouched={formik.touched} />
				</CardContent>
			</Card>
			<FormikValidation formikValues={formik.values} formikErrors={formik.errors} formikTouched={formik.touched} tech={true} />
		</form>
	);
}

export default MessageForm;